<div id="baseFooter2">
  <div class="corpo container">
    <div class="row">
      <div class="col-md-4"> <i class="large material-icons">library_books</i>
        <p>Em caso de dúvidas, acesse o<br> <strong><a href="https://aw.fhe.org.br/formulariosweb/formContatoCerel?origem=poupex" target="_blank">Formulário de Atendimento</a></strong></p> <br clear="all"> <i class="large material-icons">call</i>
        <p> Teleatendimento aos Surdos<br> <strong>0800 646 4747</strong> </p>
      </div>
      <div class="col-md-4"> <i class="large material-icons"> chat_bubble_outline</i>
        <p>Centro de Relacionamento com o Cliente<br> <strong>0800 061 3040</strong></p> <br clear="all"> <i class="large material-icons"> ring_volume</i>
        <p>Ouvidoria<br> <strong>0800 647 8877</strong> </p>
      </div>
      <div class="col-md-4"> <a href="http://www.fhe.org.br/" target="_blank" class="img"><img src="../../assets/logotipoFHE.png" alt=""></a> <a href="http://www.poupex.com.br/" target="_blank" class="img"><img src="../../assets/logotipoPOUPEX.png" alt=""></a>      </div>
    </div>
    <div class="col-12 text-right mt-2">Versão: {{versao}}</div>
  </div>
</div>
